module.exports = __webpack_public_path__ + "static/img/logo-w.68af75e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-w.jpg
// module id = 3vwg
// module chunks = 2